const INDUSTRY_CODE_EN = Object.freeze({
    "ACCESSORIES": "Accessories",
  "ADVERTISING_AND_MARKETING_SERVICE": "Advertising And Marketing Service",
  "AMUSEMENT_PARK": "Amusement Park",
  "ASSORTED_GOODS": "Assorted Goods",
  "AUDIO_AND_VIDEO": "Audio And Video",
  "CONSTRUCTION_INFRASTRUCTURE": "Construction Infrastructure",
  "CONSULTANT_SERVICE": "Consultant Service",
  "ELECTRONIC_PRODUCT": "Electronic Product",
  "FINANCIAL_INSTITUTION": "Financial Institution",
  "FINANCIAL_SERVICE": "Financial Service",
  "FOOD_AND_BEVERAGES": "Food And Beverages",
  "FURNITURE": "Furniture",
  "GARDENING_PRODUCTS": "Gardening Products",
  "MATERNAL_AND_CHILD_PRODUCTS": "Maternal And Child Products",
  "OIL_AND_GAS_INDUSTRY": "Oil And Gas Industry",
  "PEST_CONTROL_SERVICE": "Pest Control Service",
  "PUBLIC_INSTITUTION": "Public Institution",
  "SOFTWARE_AND_IT_SERVICE": "Software And IT Service",
  "SUPPLY_CHAIN_SERVICES_PROVIDER": "Supply Chain Services Provider",
  "TOYS_AND_STATIONERY": "Toys And Stationery",
  "ACCOMMODATIONS": "Accommodations",
  "ACCOUNTING": "Accounting",
  "ADVERTISTING": "Advertising",
  "AEROSPACE": "Aerospace",
  "AGRICULTURE": "Agriculture",
  "AIR_TRANSPORTATION": "Air Transportation",
  "APPAREL_ACCESSORIES": "Apparel and Accessories",
  "AUTO": "Auto",
  "BANKING": "Banking",
  "BEAUTY_COSMETICS": "Beauty and Cosmetics",
  "BIOTECHNOLOGY": "Biotechnology",
  "CHEMICAL": "Chemical",
  "COMMUNICATIONS": "Communications",
  "COMPUTER": "Computer",
  "CONSTRUCTION": "Construction",
  "CONSULTING": "Consulting",
  "CONSUMER_PRODUCTS": "Consumer Products",
  "EDUCATION": "Education",
  "ELECTRONICS": "Electronics",
  "EMPLOYMENT": "Employment",
  "ENERGY": "Energy",
  "ENTERTAINMENT_RECREATION": "Entertainment and Recreation",
  "FASHION": "Fashion",
  "FINANCIAL_SERVICES": "Financial Services",
  "FOOD_BEVERAGE": "Food and Beverage",
  "HEALTH": "Health",
  "INFORMATION": "Information",
  "INFORMATION_TECHNOLOGY": "Information Technology",
  "JOURNALISM_NEWS": "Journalism News",
  "LEGAL_SERVICES": "Legal Services",
  "MANUFACTURING": "Manufacturing",
  "MEDIA_BROADCASTING": "Media Broadcasting",
  "MEDICAL_DEVICES_SUPPLIES": "Medical Devices and Supplies",
  "MOTION_PICTURES": "Motion Pictures",
  "MUSIC": "Music",
  "PHARMACEUTICAL": "Pharmaceutical",
  "PUBLIC_ADMINISTRATION": "Public Administration",
  "PUBLIC_RELATIONS": "Public Relations",
  "PUBLISHING": "Publishing",
  "REAL_ESTATE": "Real Estate",
  "RETAIL": "Retail",
  "SERVICE": "Service",
  "SPORTS": "Sports",
  "TECHNOLOGY": "Technology",
  "TELECOMMUNICATIONS": "Telecommunications",
  "TRANSPORTATION": "Transportation",
  "TRAVEL": "Travel and Tourism",
  "UTILITIES": "Utilities",
  "VIDEO_GAMES": "Video Games",
  "WEB_SERVICES": "Web Services",
  "OTHER": "Other",
  "ACCESSORIES_LEATHER_GOODS": "Accessories & Leather Goods",
  "ADVERTISING": "Advertising",
  "AGRICULTURAL_POULTRY_FISHING_PRODUCTION": "Agricultural, Poultry & Fishing Production",
  "AIRLINE_SERVICES": "Airline Services",
  "AIRLINE_SUPPORT": "Airline Support",
  "ALCOHOLIC_DRINKS_TOBACCO": "Alcoholic Drinks & Tobacco",
  "ALTERNATIVE_ENERGY": "Alternative Energy",
  "APPAREL": "Apparel",
  "AUTOMOBILE_RETAILING_MAINTENANCE_REPAIR": "Automobile Retailing, Maintenance & Repair",
  "AUTOMOBILES_COMPONENTS": "Automobiles & Components",
  "BANKS": "Banks",
  "CHEMICAL_PRODUCTS": "Chemical Products",
  "COAL": "Coal",
  "COMMERCIAL_VEHICLE": "Commercial Vehicle",
  "CONGLOMERATES": "Conglomerates",
  "CONSTRUCTION_DECORATION": "Construction & Decoration",
  "CONSTRUCTION_MATERIALS": "Construction Materials",
  "CONSUMER_ELECTRONICS": "Consumer Electronics",
  "COSMETICS_PERSONAL_CARE": "Cosmetics & Personal Care",
  "DAIRY_PRODUCTS": "Dairy Products",
  "DEPARTMENT_STORES_SHOPPING_MALLS": "Department Stores & Shopping Malls",
  "DIVERSIFIED_FOOD_BEVERAGE": "Diversified Food & Beverage",
  "DIVERSIFIED_TOURISM_HOTEL_RESTAURANT": "Diversified Tourism, Hotel & Restaurant",
  "E_COMMERCE_INTERNET_SERVICES": "E-Commerce & Internet Services",
  "ELECTRIC_EQUIPMENT": "Electric Equipment",
  "ELECTRICITY_SUPPLY": "Electricity Supply",
  "ELECTRONIC_COMPONENT": "Electronic Component",
  "ENVIRONMENTAL_ENERGY_MATERIAL": "Environmental Energy Material",
  "ENVIRONMENTAL_GOODS": "Environmental Goods",
  "FERTILISERS_AGRICULTURAL_CHEMICALS": "Fertilisers & Agricultural Chemicals",
  "FOOD_ADDITIVES_FLAVOURING": "Food Additives & Flavouring",
  "FOOTWEARS": "Footwears",
  "FORESTRY_TIMBER": "Forestry & Timber",
  "FUNERAL": "Funeral",
  "FURNITURE_HOUSEHOLD_GOODS": "Furniture & Household Goods",
  "GAMBLE": "Gamble",
  "GAS_SUPPLY": "Gas Supply",
  "HEALTH_PRODUCTS": "Health Products",
  "HOTELS_RESORTS": "Hotels & Resorts",
  "HOUSEHOLD_APPLIANCES": "Household Appliances",
  "INDUSTRIAL_GOODS": "Industrial Goods",
  "INFRASTRUCTURE": "Infrastructure",
  "INSURANCE": "Insurance",
  "INTERNATIONAL_TRADE": "International Trade",
  "INVESTMENTS_ASSETS_MANAGEMENT": "Investments & Assets Management",
  "IT_HARDWARE": "IT Hardware",
  "LEISURE_RECREATION": "Leisure & Recreation",
  "MACHINERY_EQUIPMENT": "Machinery & Equipment",
  "MARINE_HARBOUR_SERVICES": "Marine & Harbour Services",
  "MEDICAL_EQUIPMENT_SERVICES": "Medical Equipment & Services",
  "MEDICINE": "Medicine",
  "MOVIES_ENTERTAINMENT": "Movies & Entertainment",
  "MULTI_MEDIA_ENTERPRISE": "Multi-media Enterprise",
  "NONFERROUS_METAL": "Nonferrous Metal",
  "OTHER_FINANCIALS": "Other Financials",
  "OTHER_MINERALS": "Other Minerals",
  "OTHER_SUPPORT_SERVICES": "Other Support Services",
  "PACKAGED_FOODS": "Packaged Foods",
  "PAPERMAKING": "Papermaking",
  "PETROLEUM_GASES": "Petroleum & Gases",
  "PETROLEUM_GASES_EQUIPMENT_SERVICES": "Petroleum & Gases Equipment & Services",
  "PLASTIC": "Plastic",
  "PRECIOUS_METAL": "Precious Metal",
  "PRINTING_PUBLISHING_PACKAGING": "Printing, Publishing & Packaging",
  "PROPERTY_DEVELOPMENT": "Property Development",
  "PROPERTY_INVESTMENT": "Property Investment",
  "PROPERTY_MANAGEMENT_AGENCY": "Property Management & Agency",
  "PUBLIC_TRANSPORT": "Public Transport",
  "REAL_ESTATE_INVESTMENT_TRUST": "Real Estate Investment Trust",
  "RESTAURANTS_FAST_FOOD_SHOPS": "Restaurants & Fast Food Shops",
  "RETAILERS_TRADE": "Retailers & Trade",
  "ROAD_AND_RAILWAY": "Road and Railway",
  "SATELLITE_AEROSPACE": "Satellite & Aerospace",
  "SECURITIES": "Securities",
  "SEMICONDUCTORS": "Semiconductors",
  "SOFT_DRINKS": "Soft Drinks",
  "SOFTWARE": "Software",
  "STEEL": "Steel",
  "SYSTEM_APPLICATIONS_IT_CONSULTING": "System Applications & IT Consulting",
  "TELECOMM_NETWORKING_EQUIPMENT": "Telecomm. & Networking Equipment",
  "TELECOMM_SERVICES": "Telecomm. Services",
  "TEXTILE_APPARELS": "Textile & Apparels",
  "TOYS": "Toys",
  "TRAVEL_TOURISM": "Travel & Tourism",
  "TV_BROADCASTING": "TV & Broadcasting",
  "WAREHOUSING_LOGISTIC_SERVICES": "Warehousing & Logistic Services",
  "WATCH_JEWELLERY": "Watch & Jewellery",
  "WATER_SUPPLY": "Water Supply",
  "ELECTRONIC_PRODCUT": "Electronic Product"
});


const INDUSTRY_CODE_ZH_TW = Object.freeze({
    "ACCESSORIES": "配件",
    "ADVERTISING_AND_MARKETING_SERVICE":"廣告及營銷服務",
    "AMUSEMENT_PARK":"主題公園",
    "ASSORTED_GOODS":"各種貨品",
    "AUDIO_AND_VIDEO":"影音",
    "CONSTRUCTION_INFRASTRUCTURE":"建築及基建",
    "CONSULTANT_SERVICE":"顧問服務",
    "ELECTRONIC_PRODUCT":"電子產品",
    "FINANCIAL_INSTITUTION":"金融機構",
    "FINANCIAL_SERVICE":"金融服務",
    "FOOD_AND_BEVERAGES":"食物及飲品",
    "FURNITURE":"傢俱",
    "GARDENING_PRODUCTS":"園藝產品",
    "MATERNAL_AND_CHILD_PRODUCTS":"母嬰用品",
    "OIL_AND_GAS_INDUSTRY":"石油和天然氣工業",
    "PEST_CONTROL_SERVICE":"害蟲防治服務",
    "PUBLIC_INSTITUTION":"公共機構",
    "SOFTWARE_AND_IT_SERVICE":"軟件和資訊科技服務",
    "SUPPLY_CHAIN_SERVICES_PROVIDER":"供應鏈服務提供商",
    "TOYS_AND_STATIONERY":"玩具和文具",
    "ACCOMMODATIONS": "酒店",
    "ACCOUNTING": "會計",
    "ADVERTISTING": "廣告",
    "AEROSPACE": "航天",
    "AGRICULTURE": "農業",
    "AIR_TRANSPORTATION": "航空運輸",
    "APPAREL_ACCESSORIES": "服裝及首飾",
    "AUTO": "汽車",
    "BANKING": "銀行",
    "BEAUTY_COSMETICS": "美容及化妝品",
    "BIOTECHNOLOGY": "生物科技",
    "CHEMICAL": "化工",
    "COMMUNICATIONS": "通訊",
    "COMPUTER": "電腦",
    "CONSTRUCTION": "建築",
    "CONSULTING": "顧問",
    "CONSUMER_PRODUCTS": "消費產品",
    "EDUCATION": "教育",
    "ELECTRONICS": "電子",
    "EMPLOYMENT": "人力招聘",
    "ENERGY": "能源",
    "ENTERTAINMENT_RECREATION": "娛樂及休閒",
    "FASHION": "時裝",
    "FINANCIAL_SERVICES": "金融服務",
    "FOOD_BEVERAGE": "飲食",
    "HEALTH": "醫療",
    "INFORMATION": "信息",
    "INFORMATION_TECHNOLOGY": "信息技術",
    "JOURNALISM_NEWS": "新聞",
    "LEGAL_SERVICES": "法律服務",
    "MANUFACTURING": "製造業",
    "MEDIA_BROADCASTING": "媒體廣播",
    "MEDICAL_DEVICES_SUPPLIES": "醫療設備及用品",
    "MOTION_PICTURES": "電影",
    "MUSIC": "音樂",
    "PHARMACEUTICAL": "醫藥",
    "PUBLIC_ADMINISTRATION": "公共管理",
    "PUBLIC_RELATIONS": "公共關係",
    "REAL_ESTATE": "地產",
    "RETAIL": "零售",
    "SERVICE": "服務",
    "SPORTS": "體育",
    "TECHNOLOGY": "技術",
    "TELECOMMUNICATIONS": "電訊",
    "TRANSPORTATION": "運輸",
    "TRAVEL": "旅遊",
    "UTILITIES": "公用行業",
    "VIDEO_GAMES": "電子遊戲",
    "WEB_SERVICES": "網絡服務",
    "OTHER": "其它",
    "ACCESSORIES_LEATHER_GOODS": "服飾配件及皮革",
    "ADVERTISING": "廣告",
    "AGRICULTURAL_POULTRY_FISHING_PRODUCTION": "農畜漁產品",
    "AIRLINE_SERVICES": "航空服務",
    "AIRLINE_SUPPORT": "航空支援",
    "ALCOHOLIC_DRINKS_TOBACCO": "煙酒",
    "ALTERNATIVE_ENERGY": "替代能源",
    "APPAREL": "服裝",
    "AUTOMOBILE_RETAILING_MAINTENANCE_REPAIR": "汽車零售及維護維修",
    "AUTOMOBILES_COMPONENTS": "汽車及零部件",
    "BANKS": "銀行",
    "CHEMICAL_PRODUCTS": "化工產品",
    "COAL": "煤炭",
    "COMMERCIAL_VEHICLE": "商用交通工具",
    "CONGLOMERATES": "綜合企業",
    "CONSTRUCTION_DECORATION": "建築及裝修",
    "CONSTRUCTION_MATERIALS": "建築材料",
    "CONSUMER_ELECTRONICS": "電子消費品",
    "COSMETICS_PERSONAL_CARE": "美容及個人護理",
    "DAIRY_PRODUCTS": "乳製品",
    "DEPARTMENT_STORES_SHOPPING_MALLS": "超市/百貨/商城",
    "DIVERSIFIED_FOOD_BEVERAGE": "綜合飲食製造",
    "DIVERSIFIED_TOURISM_HOTEL_RESTAURANT": "綜合旅遊、酒店及餐飲",
    "E_COMMERCE_INTERNET_SERVICES": "電子商貿及互聯網服務",
    "ELECTRIC_EQUIPMENT": "電氣設備",
    "ELECTRICITY_SUPPLY": "供電供熱",
    "ELECTRONIC_COMPONENT": "電子元器件",
    "ENVIRONMENTAL_ENERGY_MATERIAL": "新能源材料",
    "ENVIRONMENTAL_GOODS": "環保",
    "FERTILISERS_AGRICULTURAL_CHEMICALS": "化肥農藥",
    "FOOD_ADDITIVES_FLAVOURING": "食品添加劑及調味料",
    "FOOTWEARS": "鞋類",
    "FORESTRY_TIMBER": "林木業",
    "FUNERAL": "殯儀",
    "FURNITURE_HOUSEHOLD_GOODS": "家具及家居用品",
    "GAMBLE": "博彩",
    "GAS_SUPPLY": "燃氣供應",
    "HEALTH_PRODUCTS": "保健品",
    "HOTELS_RESORTS": "酒店及度假村",
    "HOUSEHOLD_APPLIANCES": "家用電器",
    "INDUSTRIAL_GOODS": "工業用品",
    "INFRASTRUCTURE": "基建",
    "INSURANCE": "保險",
    "INTERNATIONAL_TRADE": "進出口貿易",
    "INVESTMENTS_ASSETS_MANAGEMENT": "投資及資產管理",
    "IT_HARDWARE": "資訊科技器材",
    "LEISURE_RECREATION": "休閒娛樂",
    "MACHINERY_EQUIPMENT": "機械裝備及器材",
    "MARINE_HARBOUR_SERVICES": "航運及港務",
    "MEDICAL_EQUIPMENT_SERVICES": "醫療器械及服務",
    "MEDICINE": "藥品",
    "MOVIES_ENTERTAINMENT": "影視娛樂",
    "MULTI_MEDIA_ENTERPRISE": "綜合媒體企業",
    "NONFERROUS_METAL": "有色金屬",
    "OTHER_FINANCIALS": "其他金融",
    "OTHER_MINERALS": "其他礦物",
    "OTHER_SUPPORT_SERVICES": "其他支援服務",
    "PACKAGED_FOODS": "包裝食品",
    "PAPERMAKING": "造紙",
    "PETROLEUM_GASES": "石油及天然氣",
    "PETROLEUM_GASES_EQUIPMENT_SERVICES": "石油天然氣設備及服務",
    "PRECIOUS_METAL": "貴金屬",
    "PLASTIC": "塑膠",
    "PRINTING_PUBLISHING_PACKAGING": "印刷及包裝",
    "PROPERTY_DEVELOPMENT": "地產發展",
    "PROPERTY_INVESTMENT": "地產投資",
    "PROPERTY_MANAGEMENT_AGENCY": "物業管理及代理",
    "PUBLIC_TRANSPORT": "公用運輸",
    "PUBLISHING": "出版傳媒",
    "REAL_ESTATE_INVESTMENT_TRUST": "房地產投資信託基金",
    "RESTAURANTS_FAST_FOOD_SHOPS": "餐飲",
    "RETAILERS_TRADE": "零售/貿易",
    "ROAD_AND_RAILWAY": "公路及鐵路",
    "SATELLITE_AEROSPACE": "衛星及航天科技",
    "SECURITIES": "證券",
    "SEMICONDUCTORS": "半導體",
    "SOFT_DRINKS": "軟飲料",
    "SOFTWARE": "軟件開發",
    "STEEL": "鋼鐵",
    "SYSTEM_APPLICATIONS_IT_CONSULTING": "系統開發及信息科技顧問",
    "TELECOMM_NETWORKING_EQUIPMENT": "電訊及網絡器材",
    "TELECOMM_SERVICES": "電訊服務",
    "TEXTILE_APPARELS": "紡織及制衣",
    "TOYS": "玩具",
    "TRAVEL_TOURISM": "旅遊及觀光",
    "TV_BROADCASTING": "電視廣播",
    "WAREHOUSING_LOGISTIC_SERVICES": "倉儲物流",
    "WATCH_JEWELLERY": "鐘錶珠寶",
    "WATER_SUPPLY": "水務供應",
    "ELECTRONIC_PRODCUT": "電子產品"
});

export {
    INDUSTRY_CODE_EN,
    INDUSTRY_CODE_ZH_TW
}